import { createI18n } from 'vue-i18n'

import enDefault from '@/i18n/en/default.ts'

import frActions from '@/i18n/fr/actions.ts'
import frAlt from '@/i18n/fr/alt.ts'
import frDefault from '@/i18n/fr/default.ts'
import frPersonas from '@/i18n/fr/personas.ts'
import frPhases from '@/i18n/fr/phases.ts'
import frPrinciples from '@/i18n/fr/principles.ts'

export default createI18n({
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    en: {
      ...enDefault,
    },
    fr: {
      ...frDefault,
      actions: frActions,
      alt: frAlt,
      personas: frPersonas,
      phases: frPhases,
      principles: frPrinciples,
    },
  },
})
